module.exports = __webpack_public_path__ + "static/media/newbanner.b7c12014.png";